<template>
  <div class="content">
    <div class="pages" v-if="this.total">
      <span style="color: #000"
        >{{
          this.pageNumber > 1
            ? (this.pageNumber - 1) * this.onPage + 1 + " -"
            : ""
        }}
        {{
          Math.round(this.total) / this.onPage > 1
            ? this.pageNumber * this.onPage
            : this.total
        }}</span
      >
      <span style="font-weight: 400"> na </span>
      <span style="color: #000">{{ this.total }}</span>
    </div>
    <div class="icons">
      <img
        src="../icons/arrowLeft.svg"
        @click="previousPage()"
        class="leftArrow"
        v-if="this.pageNumber > 1"
      />
      <img
        src="../icons/arrowLeftDisabled.svg"
        v-else
        class="disabled-icon leftArrow"
      />

      <img
        src="../icons/arrowRight.svg"
        @click="nextPage()"
        class="rightArrow"
        v-if="calcPage()"
      />
      <img
        src="../icons/arrowRightDisabled.svg"
        v-else
        class="disabled-icon rightArrow"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationArrows",
  props: ["pageNumber", "onPage", "total"],
  data() {
    return {
      showAll: false,
    };
  },
  emits: ["nextPage", "previousPage"],

  methods: {
    calcPage() {
      const page_number = this.pageNumber;
      const total_value = this.total;
      const on_page = this.onPage;

      if (total_value / on_page > page_number) {
        return true;
      } else {
        return false;
      }
    },
    async nextPage() {
      this.$emit("nextPage");
    },

    async previousPage() {
      this.$emit("previousPage");
    },
  },

  computed: {},
};
</script>

<style scoped>
.icons img {
  height: 30px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
}
.rightArrow {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.leftArrow {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.content {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.pages {
  font-size: 14px;
  font-weight: bold;
}
</style>
